import { useQuery } from "@tanstack/react-query";
import { getService } from "../../api/apiServices";
import i18next from "i18next";

const useGetService = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["service", id, i18next.language],
        queryFn: () => getService(id),
        enabled: !!id,
    });

    return {
        service: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetService;
